import { render, staticRenderFns } from "./ct-check.vue?vue&type=template&id=36cd74b7&scoped=true"
import script from "./ct-check.vue?vue&type=script&lang=js"
export * from "./ct-check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd74b7",
  null
  
)

export default component.exports